// extracted by mini-css-extract-plugin
export default {"container":"SgI0_","title":"J6N_U","widgetContent":"viqOx","spinner":"FewEs","item":"M67NE"};